// extracted by mini-css-extract-plugin
export default {"loading":"BhrDz2z6EzZLSaSG_Rwr-style-loading"};